import { render, staticRenderFns } from "./tabsItem.vue?vue&type=template&id=06e58c0c&scoped=true&"
import script from "./tabsItem.vue?vue&type=script&lang=js&"
export * from "./tabsItem.vue?vue&type=script&lang=js&"
import style0 from "./tabsItem.vue?vue&type=style&index=0&id=06e58c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e58c0c",
  null
  
)

component.options.__file = "tabsItem.vue"
export default component.exports